/**
 * Safely serialize a JavaScript object for embedding inside a
 * <script type="application/ld+json">...</script> block.
 *
 * `JSON.stringify` alone is NOT safe for `<script>` context: string values
 * may contain the literal sequence `</script>` (or unicode line separators),
 * which would break out of the tag and enable XSS if user-controlled data
 * ever reaches the serializer.
 *
 * This helper escapes the four dangerous characters that HTML parsers
 * treat specially inside a script element while remaining valid JSON.
 */
export const safeJsonLd = (data) => {
  try {
    return JSON.stringify(data)
      .replace(/</g, '\\u003c')
      .replace(/>/g, '\\u003e')
      .replace(/&/g, '\\u0026')
      .replace(/\u2028/g, '\\u2028')
      .replace(/\u2029/g, '\\u2029');
  } catch {
    return '{}';
  }
};

export default safeJsonLd;
